import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';
import { Input } from '@/components/ui/input';

interface EducationLevelSelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string | null; // Updated to allow null
  otherValue?: string;
  onOtherChange?: (value: string) => void;
}

export function EducationLevelSelect({ 
  value, 
  onChange, 
  error,
  otherValue = '',
  onOtherChange
}: EducationLevelSelectProps) {
  const levels = {
    primary: 'ابتدائي',
    intermediate: 'متوسط',
    secondary: 'ثانوي',
    bachelor: 'جامعي',
    master: 'ماجستير',
    doctorate: 'دكتوراه',
    other: 'أخرى',
  };

  return (
    <div className="space-y-2">
      <Select value={value || ""} onValueChange={onChange}>
        <SelectTrigger className={error ? 'border-red-500' : ''}>
          {value ? levels[value as keyof typeof levels] : 'اختر المرحلة الدراسية'}
        </SelectTrigger>
        <SelectContent>
          {Object.entries(levels).map(([key, label]) => (
            <SelectItem key={key} value={key}>{label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      
      {value === 'other' && (
        <Input
          value={otherValue}
          onChange={(e) => onOtherChange?.(e.target.value)}
          placeholder="أدخل المرحلة الدراسية"
          className={`mt-2 ${error ? 'border-red-500' : ''}`}
        />
      )}
      
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}